import axios, { getData } from 'lib/axios'

// get employee staffs at main page
export const getAllStaffEmployees = async () => {
  return axios.get('/staff-list').then(getData)
}

// post invite staff individual
export const postInviteStaffIndividual = async (data) => {
  return axios.post('/staff-invite/individual', data).then(getData)
}

// post invite staff import
export const postInviteStaffImport = async (data) => {
  return await axios.post('/staff-invite/import', data).then(getData)
}

// post invite staff bulk
export const postInviteStaffBulk = async (data) => {
  return axios.post('/staff-invite/bulk', data).then(getData)
}

// get detailed info of employee staff in personal tab
export const getPersonalData = (id) => {
  return axios.get(`employee-file/personal/${id}`)
}

// post detailed info of employee staff in personal tab
export const postPersonalData = (id, data) => {
  return axios.post(`employee-file/personal/${id}`, data)
}

// get employment info of employee staff in employment tab
export const getEmploymentData = (id) => {
  return axios.get(`employee-file/employment/${id}`)
}

// post employment info of employee staff in personal tab
export const postEmploymentData = (id, data) => {
  return axios.post(`employee-file/employment/${id}`, data)
}

// get bank and statutory info of employee staff in bank tab
export const getBankData = (id) => {
  return axios.get(`employee-file/bank-statutory/${id}`)
}

// post bank and statutory info of employee staff in bank tab
export const postBankData = (id, data) => {
  return axios.post(`employee-file/bank-statutory/${id}`, data)
}

// get tax info of employee staff in tax tab
export const getTaxData = (id) => {
  return axios.get(`employee-file/tax/${id}`)
}

// post tax info of employee staff in tax tab
export const postTaxData = (id, data) => {
  return axios.post(`employee-file/tax/${id}`, data)
}

// get allocation info of employee staff in allocation tab
export const getAllocationData = (id) => {
  return axios.get(`/employee-file/allocation/${id}`)
}

// update employee leave allocation in allocation tab
export const putLeaveAllocationData = (id, data) => {
  return axios.put(`/employee-file/allocation/${id}/leave`, data).then(getData)
}

// get progress info of employee staff
export const getProgressStaff = (id) => {
  return axios.get(`employee-file/progress/${id}`)
}

// post bank and statutory info of employee staff in bank tab
export const postAllData = (id, data) => {
  return axios.post(`employee-file/all/${id}`, data)
}

// get uninvited staff that forgot password
export const getUninvitedStaffData = async () => {
  return axios.get('/staff-reinvite-list').then(getData)
}

export const exportActiveStaffEmployeeFile = async (format = 'xlsx', staffIds) => {
  return axios.get('/employee-file/export', {
    params: {
      format,
      employment_status: 1,
      ...(staffIds ? { staff_ids: staffIds } : {}),
    },
    responseType: 'blob',
  })
}

// to resend email invitation to employees
export const postReinviteStaff = (data) => {
  return axios.post(`/staff-reinvite/selected`, data)
}

// terminate employee
export const terminateEmployee = (employee_id, data) => {
  return axios.post(`terminate-staff/${employee_id}`, data)
}

// cancel a termination that has not passed its inclusive last working day
export const cancelEmployeeTermination = (employee_id) => {
  return axios.post(`cancel-termination/${employee_id}`)
}

// rehire a terminated employee
export const rehireEmployee = (employee_id, data) => {
  return axios.post(`staff/${employee_id}/rehire`, data)
}

// preview responsibilities and pending leave affected by staff termination
export const getTerminationImpact = (employee_id, offboardingDate) => {
  return axios
    .get(`staff/${employee_id}/termination-impact`, {
      params: { offboarding_date: offboardingDate },
    })
    .then(getData)
}

// available payslip for employee
export const getMonthlyPayslip = async () => {
  const res = await axios.get(`employee-payslip`).then(getData)
  return res
}

// show individual payslip
export const displayIndividualPayslip = async (data) => {
  return axios.post(`employee-payslip`, data)
}

// available EA Form for employee
export const getYearlyEAForm = async () => {
  const res = await axios.get(`payroll/annual-report/ea-status`).then(getData)
  return res
}

// show individual EA Form
export const displayIndividualEAForm = async (year) => {
  return axios.get(`payroll/annual-report/ea-download?year=${year}`, { responseType: 'blob' })
}
